// extracted by mini-css-extract-plugin
export var label = "_h7-2";
export var slideContainer = "_h7-0";
export var slider = "_h7-1";